;(function ($) {
  'use strict';

  $(document).on('ready', function() {
    keyboard_accessibility();
  });

	function getIsMobile() {
		return $('#heroHomepageHelper').css('display') === 'none' ? true : false;
	}

  // Keyboard accessibility
  function keyboard_accessibility() {
    $(document).on('keydown', function (e) {
      let code = e.keyCode ? e.keyCode : e.which;
			let isMobile = getIsMobile();

      // ESC behaviors
      if (code == 27) {
      }

      // TAB behaviors
      if (!e.shiftKey && code == 9) {
        $('.search-toggle.active').on({
          'blur': function() {
            $('.search-toggable input[type=text]').focus();
          }
        });

        $('.search-window--press-media li:last-child a').on({
          'blur': function() {
            $('.search-toggle.active').focus();
          }
        });

				$('.hero-homepage__buttons a:last-child').on({
					'blur': function() {
						if (!isMobile) {
							$('body, html').animate({ scrollTop: 500 + 'px'}, 50);
						}
						else {
							$('body, html').animate({ scrollTop: $('.hero-homepage-step.--step-2').outerHeight()/2 + 'px'}, 50);
						}
					}
				});
			}

      // SHIFT + TAB behaviors
      if (e.shiftKey && code == 9) {

      }

      // ENTER behaviors
      if (code == 13) {
        // Ex.:
        // if ($('.form-checkbox').is(':focus')) {
        //   $('.form-checkbox:focus').trigger('click');
        // }
      }
    });
  }
})(jQuery);
